"use client";

import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
import SummaryComponent from "./Summary";
import LazySection from "@/components/common/LazySection";
import { useDeferReady } from "../_shared/useDeferReady";
import type { CastMember } from "@/types/movie";
const Crew = dynamic(() => import("./Crew"), {
  ssr: false
});
const Recommendations = dynamic(() => import("./Recommendations"), {
  ssr: false
});
const CommentsTab = dynamic(() => import("./CommentsTab").then(m => ({
  default: m.CommentsTab
})), {
  ssr: false
});
interface Props {
  movieUuid: string;
  title: string;
  summary: string;
  cast: CastMember[];
  profileUuid: string;
}
export default function MovieBelowFold(t0) {
  const $ = _c(17);
  const {
    movieUuid,
    title,
    summary,
    cast,
    profileUuid
  } = t0;
  const deferReady = useDeferReady();
  let t1;
  if ($[0] !== summary || $[1] !== title) {
    t1 = <SummaryComponent title={title} summary={summary} />;
    $[0] = summary;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== cast) {
    t2 = <LazySection minHeight={200}><Crew crew={cast} /></LazySection>;
    $[3] = cast;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== deferReady || $[6] !== movieUuid) {
    t3 = deferReady && <LazySection minHeight={300}><Recommendations entityType="movie" entityUuid={movieUuid} /></LazySection>;
    $[5] = deferReady;
    $[6] = movieUuid;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== deferReady || $[9] !== movieUuid || $[10] !== profileUuid) {
    t4 = deferReady && <LazySection minHeight={400}><CommentsTab entityType="movie" entityUuid={movieUuid} profileUuid={profileUuid} /></LazySection>;
    $[8] = deferReady;
    $[9] = movieUuid;
    $[10] = profileUuid;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
    t5 = <>{t1}{t2}{t3}{t4}</>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}